<div class="highlight-list-block">
  <!-- List View mode -->
  <ng-component [id]="'displayElement'+blockElement?.displayOrder"
    *ngIf="!blockElement?.isActiveForEdit && !blockElement?.isInHighLightMode"
    [innerHTML]="blockElement?.data"></ng-component>

  <!-- List HighLight mode -->
  <ng-component [id]="'hightLightArea'+blockElement?.displayOrder" class="hightLightAreaBox"
    (click)="addHightLight($event)" *ngIf="blockElement?.isInHighLightMode"
    [innerHTML]="blockElement?.data"></ng-component>

  <!-- List edit mode -->
  <div *ngIf="blockElement?.isActiveForEdit && !blockElement?.isInHighLightMode" class="NgxEditor__Wrapper">
    <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"> </ngx-editor-menu>
    <ngx-editor [editor]="editor" [ngModel]="blockElement.data" (ngModelChange)="onChange($event)" [disabled]="false"
      [placeholder]="'Type here...'"></ngx-editor>
  </div>
</div>